if (!customElements.get('fp-account-panel')) {
  customElements.define('fp-account-panel', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.trigger = this.querySelector('[data-fp-account-trigger]');
      this.dialog = this.querySelector('dialog');
      if (!this.trigger || !this.dialog?.showModal) return;
      this.trigger.addEventListener('click', event => {
        event.preventDefault();
        if (this.dialog.open) return this.close();
        document.querySelectorAll('details-modal').forEach(modal => { if (modal.isOpen()) modal.close(false); });
        document.querySelectorAll('predictive-search').forEach(search => search.close());
        this.restoreFocus = true;
        this.dialog.style.setProperty('--fp-account-top', `${this.trigger.getBoundingClientRect().bottom + 8}px`);
        this.dialog.showModal();
        this.trigger.setAttribute('aria-expanded', 'true');
        this.lockedScroll = !document.body.classList.contains('overflow-hidden');
        document.body.classList.add('overflow-hidden');
      }, options);
      this.dialog.addEventListener('click', event => {
        if (event.target.closest('[data-fp-account-close]')) this.close();
        else if (event.target === this.dialog) {
          const box = this.dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.close();
        }
      }, options);
      this.dialog.addEventListener('close', () => this.reset(), options);
    }
    close(focus = true) {
      if (!this.dialog?.open) return;
      this.restoreFocus = focus;
      this.dialog.close();
    }
    reset() {
      this.trigger?.setAttribute('aria-expanded', 'false');
      if (this.lockedScroll && !document.querySelector('details-modal details[open], dialog[open]')) document.body.classList.remove('overflow-hidden');
      this.lockedScroll = false;
      if (this.restoreFocus && this.trigger?.isConnected) this.trigger.focus();
    }
    disconnectedCallback() {
      this.close(false);
      this.reset();
      this.controller?.abort();
    }
  });
}
